import Box from '@mui/material/Box';
import type { ReactElement } from 'react';

import type { Channel } from '../../../api';
import { ChannelAvatar } from '../../../components/ChannelAvatar';

import { useChannelPhoto } from './use-channel-photo';

/**
 * C3 `ChannelAvatar` with the channel's photo loaded lazily (S5 R14). Decorative, like the
 * avatar: the name is written next to it and the checkbox carries it (AC21).
 */
export function ChannelPhotoAvatar({ channel }: { readonly channel: Channel }): ReactElement {
  const { url, watch } = useChannelPhoto(channel.id, channel.hasPhoto);
  return (
    <Box ref={watch} sx={{ display: 'inline-flex', flexShrink: 0 }}>
      <ChannelAvatar seed={channel.id} name={channel.title} photoUrl={url} />
    </Box>
  );
}
